module.exports = __webpack_public_path__ + "img/logo-big.8b3b9b38.png";